import * as React from 'react';
import {Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileLines} from "@fortawesome/free-solid-svg-icons";
import {Link, useLocation} from "react-router-dom";
import {SystemRoutes} from "../../../../Utils/RouteUtils";
import {useAppSelector} from "../../../../Config/Hooks";
import {hasPermission} from "../../../Auth/AuthenticationUtil";
import {AUTHORITIES} from "../../../../Config/Constants";

const style = {
    linkItem: {
        textDecoration: "none",
        color: "inherit"
    },
};

export default function SGDRecordsMenu() {
    const theme = useTheme();
    const location = useLocation();
    const account = useAppSelector(state => state.authentication.account);

    const isAuthorizedToTeleObject = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_REPORT, AUTHORITIES.EXPORT_REPORT_TELEOBJECTS
    ]);
    const isAuthorizedToManagementReport = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_REPORT, AUTHORITIES.EXPORT_REPORT_MANAGEMENT_REPORT
    ]);
    // SGD-3700: Auditorias movidas da seção "Audit" para "Reports". Permissões preservadas (VIEW_AUDIT_*).
    const isAuthorizedToAuditCommands = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_AUDIT, AUTHORITIES.VIEW_AUDIT_COMMANDS
    ]);
    const isAuthorizedToAuditAlarms = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_AUDIT, AUTHORITIES.VIEW_AUDIT_ALARMS
    ]);

    // SGD-3700: itens abaixo foram descontinuados da seção Reports (Alarms, Performance Summary,
    // Power Plants, Equipment Classes, Equipments, Skids, Audit). Suas permissões/rotas continuam
    // existindo no sistema; mantidos comentados no JSX abaixo para eventual reuso futuro.

    return (
        <Box sx={{ width: '100%', maxWidth: 360,
            bgcolor: theme.palette.mode === 'light' ? 'background.paper' : '#1E1E1E',
            height: window.innerHeight - 90,
            borderBottomLeftRadius: '16px',
            borderBottomRightRadius: '16px',
            ml: '2%',
            mt: 1}}>
            <nav aria-label="main mailbox folders">
                <List>
                    {/* 1. Telemedidas */}
                    <Link style={style.linkItem} to={isAuthorizedToTeleObject ? SystemRoutes.REPORTS_TELEOBJECTS : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("teleobjects")}>
                            <ListItemButton disabled={!isAuthorizedToTeleObject}>
                                <ListItemIcon>
                                    <FontAwesomeIcon fontSize={20} icon={faFileLines} />
                                </ListItemIcon>
                                <ListItemText primary="Telemedidas" />
                            </ListItemButton>
                        </ListItem>
                    </Link>

                    {/* 2. Gestão */}
                    <Link style={style.linkItem} to={isAuthorizedToManagementReport ? SystemRoutes.REPORTS_MANAGEMENT_REPORT : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("managementReport")}>
                            <ListItemButton disabled={!isAuthorizedToManagementReport}>
                                <ListItemIcon>
                                    <FontAwesomeIcon fontSize={20} icon={faFileLines} />
                                </ListItemIcon>
                                <ListItemText primary="Gestão" />
                            </ListItemButton>
                        </ListItem>
                    </Link>

                    {/* 3. Auditoria de Comandos (SGD-3700: movida da seção Audit -> URL /reports/commands) */}
                    <Link style={style.linkItem} to={isAuthorizedToAuditCommands ? SystemRoutes.AUDIT_COMMANDS : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("commands")}>
                            <ListItemButton disabled={!isAuthorizedToAuditCommands}>
                                <ListItemIcon>
                                    <FontAwesomeIcon fontSize={20} icon={faFileLines} />
                                </ListItemIcon>
                                <ListItemText primary="Auditoria de Comandos" />
                            </ListItemButton>
                        </ListItem>
                    </Link>

                    {/* 4. Auditoria de Alarmes (SGD-3700: movida da seção Audit -> URL /reports/alarms) */}
                    <Link style={style.linkItem} to={isAuthorizedToAuditAlarms ? SystemRoutes.AUDIT_ALARMS : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("alarms")}>
                            <ListItemButton disabled={!isAuthorizedToAuditAlarms}>
                                <ListItemIcon>
                                    <FontAwesomeIcon fontSize={20} icon={faFileLines} />
                                </ListItemIcon>
                                <ListItemText primary="Auditoria de Alarmes" />
                            </ListItemButton>
                        </ListItem>
                    </Link>

                    {/* SGD-3700: itens descontinuados da seção Reports — mantidos comentados para reuso futuro.
                    <Link style={style.linkItem} to="#">
                        <ListItem disablePadding><ListItemButton disabled>
                            <ListItemIcon><FontAwesomeIcon fontSize={20} icon={faFileLines} /></ListItemIcon>
                            <ListItemText primary="Alarms" />
                        </ListItemButton></ListItem>
                    </Link>
                    <Link style={style.linkItem} to="#">
                        <ListItem disablePadding><ListItemButton disabled>
                            <ListItemIcon><FontAwesomeIcon fontSize={20} icon={faFileLines} /></ListItemIcon>
                            <ListItemText primary="Performance Summary" />
                        </ListItemButton></ListItem>
                    </Link>
                    <Link style={style.linkItem} to="#">
                        <ListItem disablePadding><ListItemButton disabled>
                            <ListItemIcon><FontAwesomeIcon fontSize={20} icon={faFileLines} /></ListItemIcon>
                            <ListItemText primary="Power Plants" />
                        </ListItemButton></ListItem>
                    </Link>
                    <Link style={style.linkItem} to="#">
                        <ListItem disablePadding><ListItemButton disabled>
                            <ListItemIcon><FontAwesomeIcon fontSize={20} icon={faFileLines} /></ListItemIcon>
                            <ListItemText primary="Equipment Classes" />
                        </ListItemButton></ListItem>
                    </Link>
                    <Link style={style.linkItem} to="#">
                        <ListItem disablePadding><ListItemButton disabled>
                            <ListItemIcon><FontAwesomeIcon fontSize={20} icon={faFileLines} /></ListItemIcon>
                            <ListItemText primary="Equipments" />
                        </ListItemButton></ListItem>
                    </Link>
                    <Link style={style.linkItem} to="#">
                        <ListItem disablePadding><ListItemButton disabled>
                            <ListItemIcon><FontAwesomeIcon fontSize={20} icon={faFileLines} /></ListItemIcon>
                            <ListItemText primary="Skids" />
                        </ListItemButton></ListItem>
                    </Link>
                    <Link style={style.linkItem} to="#">
                        <ListItem disablePadding><ListItemButton disabled>
                            <ListItemIcon><FontAwesomeIcon fontSize={20} icon={faFileLines} /></ListItemIcon>
                            <ListItemText primary="Audit" />
                        </ListItemButton></ListItem>
                    </Link>
                    */}
                </List>
            </nav>
        </Box>

    );
}
